/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../apimodel.d.ts" />
/// <reference path="app.common.filters.module.ts" />

module App.Common.Filters {
	'use strict';

	function filter(bytes: number, precision: number = 2): string {
		if (isNaN(parseFloat(bytes as any)) || !isFinite(bytes)) { return ''; }
		if (typeof precision === 'undefined') { precision = 1; }
		var units = ['bytes', 'kB', 'MB', 'GB', 'TB', 'PB'],
			number = Math.floor(Math.log(bytes) / Math.log(1024));
		return (bytes / Math.pow(1024, Math.floor(number))).toFixed(precision) + ' ' + units[number];
	};

	angular
		.module('app.common.filters')
		.filter('bytes', [() => {return filter;}]);
}